
import { reactive } from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "RegistrationPersonData",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {    
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "",
      form: "RegistrierungBenutzer",
      page: "RegistrierungPersonendaten",
      remoteId: "",
      message: "",
      title: "",
      
      
    });

    return {
      request      
    };
  }
};
